//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Multiselect from 'vue-multiselect';
export default {
    name: 'SelectInput',

    components: { Multiselect },

    props: {
        label: {
            required: false,
            type: String,
        },
        value: {
            required: false,
            type: [Object, String, Array, Number],
        },
        placeholder: {
            default: 'Select an option',
            required: false,
            type: String,
        },
        multiple: {
            default: false,
            required: false,
            type: Boolean,
        },
        taggable: {
            default: false,
            required: false,
            type: Boolean,
        },
        empty: {
            default: false,
            required: false,
            type: Boolean,
        },
        disabled: {
            required: false,
            type: Boolean,
        },
        searchable: {
            default: false,
            required: false,
            type: Boolean,
        },
        error: {
            default: '',
            required: false,
            type: String,
        },
        options: {
            required: true,
            type: [Array, Object],
        },
        trackBy: {
            default: '',
            required: false,
            type: String,
        },
        text: {
            default: '',
            required: false,
            type: String,
        },
        hideError: {
            default: false,
            required: false,
            type: Boolean,
        },
        direction: {
            default: 'bottom',
            required: false,
            type: String,
        },
        optionsLimit: {
            default: 100,
            required: false,
            type: Number,
        },
        internalSearch: {
            default: true,
            required: false,
            type: Boolean,
        },
        loading: {
            default: false,
            required: false,
            type: Boolean,
        },
        debounce: {
            default: 0,
            required: false,
            type: Number,
        },
        sortable: {
            default: true,
            required: false,
            type: Boolean,
        },
        sortDirection: {
            type: String,
            required: false,
            default: 'asc',
            validator: (value) => ['asc', 'desc'].includes(value),
        },
    },

    data() {
        return {
            debounceTimer: null,
        };
    },

    computed: {
        sortedOptions() {
            let clone = [...this.options];

            const sortedClone =
                this.trackBy === '' && this.text === ''
                    ? clone.sort()
                    : clone.sort((a, b) => {
                          let fa = a[this.text];
                          let fb = b[this.text];
                          if (fa < fb) return -1;
                          if (fa > fb) return 1;
                          return 0;
                      });

            return this.sortDirection === 'asc' ? sortedClone : sortedClone.reverse();
        },
    },

    methods: {
        updateValue(value) {
            this.$emit('input', value);
        },

        updateSearch(query) {
            if (this.debounceTimer !== null) {
                clearTimeout(this.debounceTimer);
            }

            this.debounceTimer = setTimeout(() => {
                this.$emit('search-change', query);
            }, this.debounce);
        },
    },
};
